import React, {useState, useEffect, useRef} from "react";
import './calendar.css';
import {useNavigate} from "react-router-dom";
import {getStartOfWeek} from "../../assets/dateFunctions/dateFunctions";
import {CalendarDataFromExercise} from "../../assets/calendarDataFromExercise/CalendarDataFromExercise";
import InfoTooltip from "../../components/InfoTooltip/InfoTooltip";
import Routes from "../../assets/RoutesToPages/Routes";
import {ReactComponent as CalendarMainImg} from './img-calendar/main-calendar-img.svg';


const CalendarPage = () => {
  const navigate = useNavigate();
  const userID = localStorage.getItem('userHash') ?? null;
  const workoutFeedbackData = JSON.parse(localStorage.getItem(userID))?.workoutFeedbackData ?? null;
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTrainingDayData, setSelectedTrainingDayData] = useState(null);
  const [isShownUserStatistics, setIsShownUserStatistics] = useState(false);
  const [isShownWaterBalanceUserStatistics, setIsShownWaterBalanceUserStatistics] = useState(false);
  const [isShownAdditionalInfo, setIsShownAdditionalInfo] = useState(false);
  const difficultySpecifiedTraining = workoutFeedbackData ?
    workoutFeedbackData.map(item => {
      return {
        date: item.date,
        difficulty: item["user-data"].difficultyExercise,
      };
    }) : [];
  const isRecordedUserResponse = workoutFeedbackData ? workoutFeedbackData.map(item => {
    return {
      date: item.date,
      isRecordedUserResponse: item["user-data"].isRecordedUserResponse
    };
  }) : [];
  let difficultyAndDateData;
  const daysName = ['Mon', 'Tue', 'Wed', "Thu", 'Fri', 'Sat', 'Sun'];
  const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const startOfWeek = getStartOfWeek(startOfMonth); // Get the start of the week
  const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const daysInMonth = [];
  const singleInfoImgRef = useRef(null);
  const [selectedWaterAmountDayData, setSelectedWaterAmountDayData] = useState(null);
  let localData = JSON.parse(localStorage.getItem(userID)) ?? null;
  const calendarContainerRef = useRef(null);
  const timerFadeIn = useRef(null);


  useEffect(() => {
    if (calendarContainerRef.current) {
      calendarContainerRef.current.classList.add('calendar-container-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      calendarContainerRef.current.classList.remove('calendar-container-fade-in');
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  useEffect(() => {
    if (userID === null || (workoutFeedbackData === null && waterBalanceData === null)) {
      navigate(Routes.mainPage);
    }
  }, [workoutFeedbackData, userID]);


  useEffect(() => {
    if (localData === null) {
      navigate(Routes.mainPage);
    }
  }, [localData]);


  const waterBalanceData = JSON.parse(localStorage.getItem(userID))?.waterBalanceData ?? null;


  (function createCalendar() {
    let currentDay = startOfWeek;
    while (currentDay <= endOfMonth || currentDay.getDay() !== 1) {
      daysInMonth.push(new Date(currentDay));
      currentDay.setDate(currentDay.getDate() + 1);
    }
  })()


  const changeMonth = (offset) => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + offset, currentDate.getDate()));
  };


  const isCurrentMonth = (day) => {
    return day.getMonth() === currentDate.getMonth() && day.getFullYear() === currentDate.getFullYear();
  };


  const isToday = (day) => {
    const dayDateString = `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}`;
    return dayDateString === new Date().toISOString().split('T')[0];
  }


  const checkIfFeedbackExist = (day) => {
    const dayDateString = `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}`;

    const feedback = isRecordedUserResponse.find(item => {
      if (!item.date || typeof item.date !== 'string') {
        console.error('Invalid date value:', item.date);
        return false;
      }

      const feedbackDate = new Date(item.date);
      if (isNaN(feedbackDate)) {
        console.error('Invalid date value:', item.date);
        return false;
      }

      const feedbackDateString = feedbackDate.toISOString().split('T')[0];
      return feedbackDateString === dayDateString && item.isRecordedUserResponse;
    });

    difficultyAndDateData = difficultySpecifiedTraining.find(item => {
      return ((new Date(item.date).toISOString().split('T')[0]) === dayDateString) && item.difficulty;
    })

    return feedback && difficultyAndDateData ? feedback.isRecordedUserResponse : false;
  };


  const checkIfWaterBalanceExist = (day, value) => {
    const dayDateString = `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}`;
    const feedback = waterBalanceData ? waterBalanceData.find(item => {
      const feedbackDate = new Date(item.date);
      const feedbackDateString = feedbackDate.toISOString().split('T')[0];
      return feedbackDateString === dayDateString && item[value];
    }) : false;

    return feedback;
  }


  const handleChooseDay = (day) => ({target}) => {
    const selectedDayDate = `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}`;

    if (day < startOfMonth) {
      changeMonth(-1);

      setTimeout(() => {
        checkHasTargetExercise();
      }, 0)
    } else if (day > endOfMonth) {
      changeMonth(1);

      setTimeout(() => {
        checkHasTargetExercise();
      }, 0)
    }

    target.classList.add('clicked-active');

    setTimeout(() => {
      target.classList.remove('clicked-active');
    }, 305)

    setSelectedDate(day.toLocaleDateString("en-GB", {day: 'numeric', month: 'long', year: 'numeric'}));

    const checkHasTargetExercise = () => {
      if (target.classList.contains('hard') ||
        target.classList.contains('medium') ||
        target.classList.contains('standart')) {
        setIsShownUserStatistics(true);
      } else {
        setIsShownUserStatistics(false);
      }

      const currentExerciseDayData = workoutFeedbackData ? workoutFeedbackData.find(elem => {
        return elem.date === selectedDayDate ?? elem;
      }) : null;

      if (currentExerciseDayData !== null) {
        setSelectedTrainingDayData(currentExerciseDayData);
      }

      const currentWaterBalanceDayData = waterBalanceData ? waterBalanceData.find(item => {
        return item.date === selectedDayDate ?? item;
      }) : null;

      if (currentWaterBalanceDayData !== null) {
        setSelectedWaterAmountDayData(currentWaterBalanceDayData);
      }

      if (target.classList.contains('water') ||
        target.classList.contains('challenge')
      ) {
        setIsShownWaterBalanceUserStatistics(true);
      } else {
        setIsShownWaterBalanceUserStatistics(false);
      }

      setSelectedDate(new Date(day).toLocaleDateString("en-GB", {day: 'numeric', month: 'long', year: 'numeric'}))
    }

    checkHasTargetExercise();
  };


  const checkIsExerciseDayUserData = (day) => {
    const dayDateString = `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}`;
    const currentDay = new Date().toISOString().split('T')[0];

    if (dayDateString === currentDay) {
      let currentExerciseDayData;
      if (workoutFeedbackData !== null) {
        currentExerciseDayData = workoutFeedbackData.find(elem => {
          return elem.date === currentDay ?? elem;
        })
      }

      if (currentExerciseDayData) {
        setSelectedTrainingDayData(currentExerciseDayData);
        setIsShownUserStatistics(true);
      } else {
        setIsShownUserStatistics(false);
      }

      let currentWaterBalanceDayData;
      if (waterBalanceData) {
        currentWaterBalanceDayData = waterBalanceData.find(item => {
          return item.date === currentDay ?? item;
        })
      }

      if (currentWaterBalanceDayData) {
        setSelectedWaterAmountDayData(currentWaterBalanceDayData);
        setIsShownWaterBalanceUserStatistics(true);
      } else {
        setIsShownWaterBalanceUserStatistics(false);
      }
    }
  }


  useEffect(() => {
    daysInMonth.forEach(day => {
      return checkIsExerciseDayUserData(day);
    })
  }, []);


  const checkIsExerciseDayOtherMonth = (day) => {
    const dayDateString = `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}`;
    // let currentDay = currentDate.toLocaleDateString().split('T')[0];
    // const [specifiedDay, month, year] = currentDay.split('.');
    // currentDay = `${year}-${month.padStart(2, '0')}-${specifiedDay.padStart(2, '0')}`;
    const currentDay = currentDate.toISOString().split('T')[0];

    if (dayDateString === currentDay) {
      let currentExerciseDayData;
      if (workoutFeedbackData !== null) {
        currentExerciseDayData = workoutFeedbackData.find(elem => {
          return elem.date === currentDay ?? elem;
        })
      }

      if (currentExerciseDayData) {
        setSelectedTrainingDayData(currentExerciseDayData);
        setIsShownUserStatistics(true);
      } else {
        setIsShownUserStatistics(false);
      }

      let currentWaterBalanceDayData;
      if (waterBalanceData) {
        currentWaterBalanceDayData = waterBalanceData.find(item => {
          return item.date === currentDay ?? item;
        })
      }

      if (currentWaterBalanceDayData) {
        setSelectedWaterAmountDayData(currentWaterBalanceDayData);
        setIsShownWaterBalanceUserStatistics(true);
      } else {
        setIsShownWaterBalanceUserStatistics(false);
      }
    }
  }


  useEffect(() => {
    daysInMonth.forEach(day => {
      setSelectedDate(currentDate.toLocaleDateString("en-GB", {day: '2-digit', month: 'long', year: 'numeric'}))
      checkIsExerciseDayOtherMonth(day);
    })
  }, [currentDate]);


  const handleShowAdditionalInfo = () => {
    setIsShownAdditionalInfo(!isShownAdditionalInfo);
  }


  useEffect(() => {
    window.addEventListener('click', e => {
      if (e.target !== singleInfoImgRef.current) {
        setIsShownAdditionalInfo(false);
      }
    })
  }, []);


  return (
    <div ref={calendarContainerRef}
         className='calendar-container'>
      <CalendarMainImg className="calendar-content-logo"
                       width='164'
                       height='164'/>
      <p className='calendar-container__title'>Calendar</p>
      <div className="calendar-content-container">
        <div className='calendar-content'>
          <div className='calendar-container-navigation'>
            <img className='calendar-navigation__arrow'
                 onClick={() => navigate(-1)}
                 loading="lazy"
                 src={require("./img-calendar/back_arrow.svg").default}
                 width='24'
                 height='24'
                 alt="image arrow left"/>
          </div>
          <div className="calendar-outer-container">
            <img ref={singleInfoImgRef}
                 className='single-info-img'
                 onClick={handleShowAdditionalInfo}
                 loading="lazy"
                 src={require('./img-calendar/info-circle-color.svg').default}
                 alt="activities info image"/>
            {
              isShownAdditionalInfo ?
                <InfoTooltip/> : null
            }
            <div className='calendar-content__navigation'>
              <button className='arrow-btn arrow-left-btn'
                      onClick={() => changeMonth(-1)}>
                <img loading="lazy"
                     src={require('./img-calendar/arrow-left.svg').default}
                     width={24}
                     height={24}
                     alt="arrow left"/>
              </button>
              <h2 className='calendar-content__navigation-title'>
                {currentDate.toLocaleString("en-US", {month: "long"})} {currentDate.getFullYear()}
              </h2>
              <button className='arrow-btn arrow-right-btn'
                      onClick={() => changeMonth(1)}>
                <img loading="lazy"
                     src={require('./img-calendar/arrow-right.svg').default}
                     width={24}
                     height={24}
                     alt="arrow right"/>
              </button>
            </div>
            <div className="calendar-inner-container__days">
              {daysName.map((item, index) => {
                return <span className='week-day' key={index}>{item}</span>
              })}
            </div>
            <div className='calendar-inner-container'>
              {daysInMonth.map((day) => {
                return (
                  <div className={`calendar-day ${isCurrentMonth(day) ? 'day-current-month' : ''}
                  ${isToday(day) && !checkIfFeedbackExist(day) ? 'today' : ''}
                  ${isCurrentMonth(day) &&
                  (checkIfWaterBalanceExist(day, "lactoseFreeDays") ||
                    checkIfWaterBalanceExist(day, "noSugarDays") ||
                    checkIfWaterBalanceExist(day, "soberDays"))
                    ? "challenge" : ''}
                  ${isCurrentMonth(day) && checkIfWaterBalanceExist(day, 'waterAmount') ? 'water' : ''}
                  ${isCurrentMonth(day) && checkIfFeedbackExist(day) ?
                    difficultyAndDateData.difficulty : ''}`}
                       key={day}
                       onClick={handleChooseDay(day)}>
                    {day.getDate()}
                  </div>
                )
              })}
            </div>
          </div>
          {selectedDate && (<h3 className='current-date'>{selectedDate}</h3>)}
          <div className="general-user-activities-container">
            {isShownUserStatistics && (
              <div className='user-activities'>
                <div className='feeling-calendar-container'>
                  <div className="feeling-calendar-img__container">
                    <img className='feeling-calendar-img'
                         loading="lazy"
                         src={CalendarDataFromExercise["feeling-estimation"]
                           [selectedTrainingDayData["user-data"]["feelingEstimation"]].image}
                         width={18}
                         height={'auto'}
                         alt="image mood"/>
                  </div>
                  <span className='feeling-calendar-description'>
                  {CalendarDataFromExercise["feeling-estimation"]
                    [selectedTrainingDayData["user-data"]["feelingEstimation"]].description}
                </span>
                </div>

                <div className='difficulty-calendar-container'>
                  <div className="difficulty-calendar-img__container">
                    <img className='training-calendar-img'
                         loading="lazy"
                         src={CalendarDataFromExercise["training-images"]
                           [selectedTrainingDayData["user-data"]["exerciseName"]]}
                         width={36}
                         height={'auto'}
                         alt="image training"/>
                  </div>
                  <div className="difficulty-calendar-container-description">
                    <h1 className='difficulty-calendar-title'>
                      {/* use 'exerciseNameLocal for not Englich lang' */}
                      {selectedTrainingDayData['user-data'].exerciseName} 
                    </h1>
                    <span className='difficulty-calendar-description'>
                  {CalendarDataFromExercise["workout-exertion"]
                    [selectedTrainingDayData["user-data"]["workoutEstimation"]].description}
                </span>
                  </div>
                </div>

                <div className='heartbeats-calendar-container'>
                  <div className="heartbeats-calendar-img__container">
                    <img className='heartbeats-calendar-img'
                         loading="lazy"
                         src={require('./img-calendar/heartbeats.png')}
                         width={18}
                         height={'auto'}
                         alt="image heart"/>
                  </div>
                  <span className='heartbeats-calendar-description'>
                  {selectedTrainingDayData['user-data'].heartBeatsEstimation < 110 ?
                    <>
                      Your post-workout heart rate was
                      <span className='heartbeats-value'> {selectedTrainingDayData['user-data'].heartBeatsEstimation}
                  </span> beats per minute, which is lower than normal
                    </>
                    :
                    selectedTrainingDayData['user-data'].heartBeatsEstimation >= 110 &&
                    selectedTrainingDayData['user-data'].heartBeatsEstimation <= 150 ?
                      <>
                        Your post-workout heart rate was
                        <span className='heartbeats-value'> {selectedTrainingDayData['user-data'].heartBeatsEstimation}
                  </span> beats per minute, which is normal
                      </>
                      :
                      <>
                        Your post-workout heart rate was
                        <span className='heartbeats-value'> {selectedTrainingDayData['user-data'].heartBeatsEstimation}
                  </span> beats per minute, which is higher than normal
                      </>
                  }
                </span>
                </div>
              </div>
            )}
            {selectedWaterAmountDayData && !!selectedWaterAmountDayData["waterAmount"]
              && isShownWaterBalanceUserStatistics && (
                <div className='water-balance-outer-container'>
                  <div className='water-balance-inner-container'>
                    <div className="water-balance-container-img">
                      <img className='water-balance-img'
                           src={require('./img-calendar/drop-img_new.png')}
                           width={18}
                           height={'auto'}
                           alt="drop image"/>
                    </div>
                    <p className="water-balance-container__description">
                      During this day you drank:
                      <br/>
                      <span className='water-balance-value'>
                      {selectedWaterAmountDayData['waterAmount']}
                    </span> ml of water.
                    </p>
                  </div>
                </div>
              )}
            {selectedWaterAmountDayData && !!selectedWaterAmountDayData["lactoseFreeDays"]
              && isShownWaterBalanceUserStatistics && (
                <div className='water-balance-outer-container'>
                  <div className='water-balance-inner-container'>
                    <div className="water-balance-container-img">
                      <img className='water-balance-img'
                           src={require('./img-calendar/lactose-challenge-img.png')}
                           width={18}
                           height={'auto'}
                           alt="cup image"/>
                    </div>
                    <p className="water-balance-container__description">
                      Lactose-free challenge:
                      <br/>
                      <span className='water-balance-value'>
                      {selectedWaterAmountDayData['lactoseFreeDays']}
                    </span> day progress
                    </p>
                  </div>
                </div>
              )}
            {selectedWaterAmountDayData && !!selectedWaterAmountDayData["noSugarDays"]
              && isShownWaterBalanceUserStatistics && (
                <div className='water-balance-outer-container'>
                  <div className='water-balance-inner-container'>
                    <div className="water-balance-container-img">
                      <img className='water-balance-img'
                           src={require('./img-calendar/lactose-challenge-img.png')}
                           width={18}
                           height={'auto'}
                           alt="cup image"/>
                    </div>
                    <p className="water-balance-container__description">
                      No Sugar Time challenge:
                      <br/>
                      <span className='water-balance-value'>
                      {selectedWaterAmountDayData['noSugarDays']}
                    </span> day progress
                    </p>
                  </div>
                </div>
              )}
            {selectedWaterAmountDayData && !!selectedWaterAmountDayData["soberDays"]
              && isShownWaterBalanceUserStatistics && (
                <div className='water-balance-outer-container'>
                  <div className='water-balance-inner-container'>
                    <div className="water-balance-container-img">
                      <img className='water-balance-img'
                           src={require('./img-calendar/lactose-challenge-img.png')}
                           width={18}
                           height={'auto'}
                           alt="cup image"/>
                    </div>
                    <p className="water-balance-container__description">
                      Sober challenge:
                      <br/>
                      <span className='water-balance-value'>
                      {selectedWaterAmountDayData['soberDays']}
                    </span> day progress
                    </p>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarPage;